import { Box, Typography } from "@mui/material";
import { dataGridCustomizations } from "../../../theme/customizations";
import AppTheme from "../../../theme/AppTheme";
import { CssBaseline } from "@mui/material";
import ComingSoon from "../../ComingSoonPage";

const CreateCampaign = (props: { disableCustomTheme?: boolean }) => {
  const xThemeComponents = {
    ...dataGridCustomizations,
  };

  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
      <CssBaseline enableColorScheme />
      <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
        <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
          Create Campaign
        </Typography>
        <ComingSoon />
      </Box>
    </AppTheme>
  );
};

export default CreateCampaign;

